import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";
import { handleGetRequest } from "../../services/GetTemplate";
import { Button } from "primereact/button";
import { FaBook, FaCheck, FaTimes } from "react-icons/fa";
import UpdateCompany from "./UpdateCompany";
import AddNewCompany from "./AddNewCompany";
import { useHistory } from "react-router-dom";
import { FaDoorOpen } from "react-icons/fa";
import { useSelector } from "react-redux";

function AllCompanies() {
  const [loading, setloading] = useState(false);
  const [data, setdata] = useState([]);
  const history = useHistory();
  const auth = useSelector((state) => state?.authenticationSlice);
  const userTypeId = auth?.userTypeId;
  let api = "company/all";

  if (userTypeId === 2 || userTypeId === "2") {
    api = "company/id/" + auth?.companyId;
  }

  const getAllCompanies = async () => {
    setloading(true);
    const res = await handleGetRequest(api);
    setdata(res?.data);
    setloading(false);
  };

  const actionTemplate = (rowData) => {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Button
          icon="pi pi-user"
          onClick={() => history.push(`/companyusers/${rowData?.companyId}`)}
          className="p-button-rounded p-button-success p-mr-2"
          tooltip="Company Users"
          tooltipOptions={{ position: "top" }}
        />
        <Button
          className="p-button-rounded p-button-info p-mr-2"
          onClick={() => {
            history.push(`/companygates/${rowData?.companyId}`);
          }}
          tooltip="Company Gates"
          tooltipOptions={{ position: "top" }}
        >
          <FaDoorOpen />
        </Button>
        <Button
          className="p-button-rounded p-button-warning p-mr-2"
          onClick={() => {
            history.push(`/gatelogs/${rowData?.companyId}`);
          }}
          tooltip="Company Gate Logs"
          tooltipOptions={{ position: "top" }}
        >
          <FaBook />
        </Button>
        {userTypeId === 1 ||
          (userTypeId === "1" && (
            <UpdateCompany data={rowData} getAllCompanies={getAllCompanies} />
          ))}
      </div>
    );
  };

  const statusTemplate = (rowData) => {
    if (rowData?.activeInactive === 1) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <FaCheck style={{ color: "green", marginRight: "5px" }} />
          <span>Active</span>
        </div>
      );
    } else {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <FaTimes style={{ color: "red", marginRight: "5px" }} />
          <span>Inactive</span>
        </div>
      );
    }
  };

  useEffect(() => {
    getAllCompanies();
  }, []); // eslint-disable-line

  return (
    <>
      <div>
        <div className="card">
          {userTypeId === 1 ||
            (userTypeId === "1" && (
              <AddNewCompany getAllCompanies={getAllCompanies} />
            ))}

          <DataTable
            header="All Companies"
            scrollable
            scrollHeight="400px"
            style={{ minWidth: "50rem" }}
            tableStyle={{ minWidth: "50rem" }}
            dataKey="companyId"
            loading={loading}
            paginator
            rows={10}
            value={data}
            emptyMessage="No data found."
          >
            <Column
              field="companyLogo"
              header="Company Logo"
              body={(rowData) => {
                return (
                  <img
                    width="20%"
                    alt="Logo"
                    src={`data:image/png;base64,${rowData?.companyLogo}`}
                  />
                );
              }}
            />
            <Column field="companyName" header="Company Name" />
            <Column
              field="activeInactive"
              header="Status"
              body={statusTemplate}
            />
            <Column body={actionTemplate} header="Action" />
          </DataTable>
        </div>
      </div>
    </>
  );
}

export default AllCompanies;
